import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Compass, ArrowRight, Sparkles } from "lucide-react";

export function DeprecatedRouteRedirect({ 
  message = "This page has moved",
  redirectTo = "/discover",
  delay = 3000,
  showInfo = true
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [countdown, setCountdown] = useState(Math.ceil(delay / 1000));

  useEffect(() => {
    // If delay is 0, redirect immediately
    if (delay === 0) {
      navigate(redirectTo, { replace: true });
      return;
    }

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate(redirectTo, { replace: true });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, redirectTo, delay]);

  const handleSkip = () => {
    navigate(redirectTo, { replace: true });
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="glass-card max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mx-auto mb-6">
            <Compass className="w-8 h-8 text-primary animate-pulse" />
          </div>
          
          <h1 className="text-xl font-heading text-foreground mb-2">
            {message}
          </h1>
          
          <p className="text-foreground/60 text-sm mb-4">
            We&apos;ve upgraded your journey experience! You&apos;ll be redirected in {countdown} seconds.
          </p>
          
          {showInfo && (
            <div className="bg-primary/10 rounded-lg p-4 mb-6 text-left">
              <div className="flex items-center gap-2 mb-2">
                <Sparkles className="w-4 h-4 text-primary" />
                <span className="text-sm font-medium text-foreground">How Quests Work:</span>
              </div>
              <ul className="text-xs text-foreground/70 space-y-1.5 list-disc list-inside">
                <li>Browse available transformation quests</li>
                <li>Click on any quest to view details</li>
                <li>Follow the guided steps at your own pace</li>
              </ul>
            </div>
          )}
          
          <Button onClick={handleSkip} className="btn-primary w-full">
            Go to Quests Now
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export default DeprecatedRouteRedirect;
